import React from 'react'
import CrumplePopEmailEntry from './CrumplePopEmailEntry'
import CrumplePopGoogleSignin from './CrumplePopGoogleSignin'
import CrumplePopFacebookSignin from './CrumplePopFacebookSignin'


export default function CrumplePopLoginSelect({onEmailEntry, onGoogleSignin, onFacebookSignin}) {
  return (
    <div className='cpop-signin-select'>
      <CrumplePopGoogleSignin onComplete={onGoogleSignin} />
      <div className='or-header'>
        <em>Or</em>
      </div>
      <div className='w-100'>
        <CrumplePopEmailEntry onComplete={onEmailEntry} />
      </div>
    </div>
  )
}
